<template>
  <div class="bg position-relative">
    <div class="bc">
      <div class="row">
        <img class="img_1" src="/img/image/home/story_img.png" loading="lazy" alt>
        <div class="text_area">
          <div style="height: 80px;"/>
          <div class="title_area">
            <img class="img_title" src="/img/image/home/t_story.png" loading="lazy" alt="品牌故事">
            <div class="subtitle_area">
              <div class="col-auto">
                <div class="row">
                  <img class="icon" src="/img/image/icon/select_icon.png" loading="lazy" alt>
                  <div class="icon_space"/>
                  <div>
                    <div class="subtitle text-white">
                      靈感源自於粵菜脆皮豬
                    </div>
                    <div class="subtitle text-white">
                      改良成台灣人獨家風味手法
                    </div>
                  </div>
                </div>
              </div>
              <div class="subtitle_space"/>
              <div class="col-auto">
                <div class="row">
                  <img class="icon" src="/img/image/icon/select_icon.png" loading="lazy" alt>
                  <div class="icon_space"/>
                  <div>
                    <div class="subtitle text-white">
                      嚴選CAS認證
                    </div>
                    <div class="subtitle text-white">
                      台灣精品無帶骨豬五花
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="divider_top_space"/>
          <img class="divider_img" src="/img/image/home/story_line.png" loading="lazy" alt>
          <div class="divider_down_space"/>
          <div class="row story_area">
            <div class="col-auto disable-col-auto">
              <img class="img_2" src="/img/image/home/t_story.png" loading="lazy" alt="品牌故事">
            </div>
            <div class="story_space"/>
            <div class="col story_text text-white">
              滿香脆的脆皮豬靈感源自於粵菜，以台灣人獨家風味手法改良，外脆內嫩的口感和獨特的香氣，在台灣廣為人知，人們聞香而至，饕客源源不絕。
              <br>
              <br>
              脆皮豬五花採用30種以上天然辛香料調味，嚴選CAS認證台灣精品無帶骨豬五花，肉質經過大型按摩機按摩數時讓肉質更鮮嫩入味、低溫風乾15小時立即真空，並透過低溫配送至各店烤爐烘烤80分鐘，過程費時超過32小時，只為完成一條外皮酥脆肉汁軟嫩的脆皮豬五花。
              <br>
              <br>
              這讓滿香脆的脆皮豬不僅是一道料理，更是承載著對美食的熱愛與堅持，如今， "滿香脆" 的脆皮豬不僅是美食饕客的最愛，更會在宴席上享用、家庭聚會中分享，脆皮豬總是能夠帶來滿滿的幸福感和滿足感。
            </div>
          </div>
          <div class="down_space"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stage_5"
}
</script>

<style lang="scss" scoped>

.bg {
  background-image: url('/img/image/background/bg_s3.png');
  background-size: cover; /* 确保背景图像覆盖整个元素 */
  background-position: center; /* 将图像居中 */
  background-repeat: no-repeat; /* 防止图像重复 */
}

.bc {
  margin: 0 auto;
  height: auto;
  max-width: 1440px;
  //text-align: center;
}


// 圖片 肉盤醬料
.img_1 {
  max-width: 653px;
  width: 33%;
  height: auto;
  object-fit: contain;
}

@media (max-width: 1440px) {
  .img_1 {
    width: 33%;
  }
}

@media (max-width: 992px) {
  .img_1 {
    width: 0;
  }
}

.text_area {
  width: 66%;
}

@media (max-width: 1440px) {
  .text_area {
    width: 67%;
  }
}

@media (max-width: 992px) {
  .text_area {
    width: 100%;
  }
}


.title_area {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: 60px;
  margin-left: 60px;
}

@media (max-width: 1050px) {
  .title_area {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .title_area {
    justify-content: space-around;
  }
}

@media (max-width: 375px) {
  .title_area {
    margin-right: 20px;
    margin-left: 20px;
  }
}

.img_title {
  width: 0;
  height: 0;
  visibility: hidden;
}

@media (max-width: 768px) {
  .img_title {
    visibility: visible;
    width: 70px;
    height: auto;
  }
}

@media (max-width: 576px) {
  .img_title {
    width: 50px;
    height: auto;
  }
}


//勾勾ICON
.icon {
  width: 27.63px;
  height: 29.34px;
  object-fit: cover;
}


@media (max-width: 576px) {
  .icon {
    width: 4vw;
    height: 4vw;;
  }
}

.icon_space {
  width: 12px;
}

@media (max-width: 425px) {
  .icon_space {
    width: 6px;
  }
}

.subtitle_area {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

@media (max-width: 1050px) {
  .subtitle_area {
    flex-direction: column;
  }
}

@media (max-width: 992px) {
  .subtitle_area {
    flex-direction: row;
  }
}

@media (max-width: 768px) {
  .subtitle_area {
    margin-top: 55px;
    flex-direction: column;
  }
}

.subtitle {
  font-size: 20px;
  font-weight: 900;
  line-height: 28.96px;
  letter-spacing: 0.1em;
  text-align: left;
}

@media (max-width: 576px) {
  .subtitle {
    font-size: 18px;
    line-height: 20px;
  }
}

@media (max-width: 425px) {
  .subtitle {
    font-size: 16px;
    line-height: 18px;
  }
}


.subtitle_space {
  width: 40px;
  height: 40px;
}

@media (max-width: 768px) {
  .subtitle_space {
    width: 26px;
    height: 26px;
  }
}

.divider_top_space{
  height: 70px;
}
@media (max-width: 576px) {
  .divider_top_space {
    height: 35px;
  }
}


.divider_down_space{
  height: 80px;
}
@media (max-width: 576px) {
  .divider_down_space {
    height: 0;
  }
}



//分隔線
.divider_img {
  max-width: 1000px;
  width: 60vw;
  height: 2px;
}

@media (max-width: 992px) {
  .divider_img {
    width: 100%;
  }
}

@media (max-width: 576px) {
  .divider_img {
    visibility: hidden;
    height: 0;
    width: 0;
  }
}

.story_area {
  margin-left: 90px;
  margin-right: 200px;
}

@media (max-width: 1440px) {
  .story_area {
    margin-left: 6.25vw;
    margin-right: 13vw;
  }
}

@media (max-width: 992px) {
  .story_area {
    margin-left: 15vw;
    margin-right: 15vw;
  }
}

@media (max-width: 576px) {
  .story_area {
    margin-left: 8vw;
    margin-right: 8vw;
  }
}

.story_space {
  width: 75px;
}

@media (max-width: 768px) {
  .story_space {
    width: 0;
    height: 0;
    visibility: hidden;
  }
}

// 文字 品牌故事
.img_2 {
  width: 96px;
  height: auto;
  object-fit: cover; /* 确保图片覆盖整个容器，且保持比例 */
}

@media (max-width: 768px) {
  .img_2 {
    visibility: hidden;
    padding: 0;
    margin: 0;
  }
}

.disable-col-auto{
}

@media (max-width: 768px) {
  .disable-col-auto {
    visibility: hidden;
    width: 0;
    height: 0;
    padding: 0;
    margin: 0;
  }
}


.story_text {
  font-size: 18px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
}
@media (max-width: 360px) {
  .story_text {
    font-size: 16px;
    line-height: 24px;
  }
}


.down_space{
  height: 95px;
}
@media (max-width: 360px) {
  .down_space {
    height: 60px;
  }
}


</style>
